import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=2404fa80&scoped=true"
import script from "./ProductDialog.vue?vue&type=script&lang=js"
export * from "./ProductDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=2404fa80&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404fa80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2404fa80')) {
      api.createRecord('2404fa80', component.options)
    } else {
      api.reload('2404fa80', component.options)
    }
    module.hot.accept("./ProductDialog.vue?vue&type=template&id=2404fa80&scoped=true", function () {
      api.rerender('2404fa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/ProductDialog.vue"
export default component.exports